import { motion } from "framer-motion";
import { PHOTOS } from "@/data";
import { useLang } from "@/i18n";

export default function Portfolio() {
  const { t } = useLang();
  const it = t.portfolio.items;
  const ITEMS = [
    { img: PHOTOS.accent, title: it.accent.title, cat: it.accent.cat, span: "md:col-span-7", h: "h-[520px]" },
    { img: PHOTOS.bedroom, title: it.bedroom.title, cat: it.bedroom.cat, span: "md:col-span-5", h: "h-[520px]" },
    { img: PHOTOS.closet, title: it.living.title, cat: it.living.cat, span: "md:col-span-5", h: "h-[520px]" },
    { img: PHOTOS.living, title: it.closet.title, cat: it.closet.cat, span: "md:col-span-7", h: "h-[520px]" },
  ];

  return (
    <section id="portfolio" className="relative py-28 md:py-40 bg-[#080808]" data-testid="portfolio-section">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="mb-16">
          <span className="text-[#d4af37] uppercase tracking-[0.3em] text-xs flex items-center gap-3">
            <span className="h-px w-10 bg-[#d4af37]" /> {t.portfolio.eyebrow}
          </span>
          <h2 className="mt-5 font-serif-lux font-light text-4xl sm:text-6xl tracking-tight text-white">
            {t.portfolio.titleA} <span className="italic text-[#d4af37]">{t.portfolio.titleB}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {ITEMS.map((item, i) => (
            <motion.figure
              key={item.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden border border-[#d4af37]/15 ${item.span} ${item.h}`}
              data-testid={`portfolio-item-${i}`}
            >
              <img
                src={item.img}
                alt={item.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-500" />
              <figcaption className="absolute bottom-0 left-0 p-7 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <span className="text-[#d4af37] uppercase tracking-[0.25em] text-[11px]">{item.cat}</span>
                <h3 className="font-serif-lux font-light text-2xl md:text-3xl text-white mt-1">{item.title}</h3>
              </figcaption>
              <span className="absolute top-6 left-6 font-serif-lux text-[#d4af37]/70 text-lg">0{i + 1}</span>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
